import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Actions
import { setResultId, setUserId } from 'store/auth/authSlice';
// Services
import StorageService from "services/Storage.service";
// Utilities
import fetcher from "utilities/Fetcher";
import { decodeBase64 } from 'utilities/Utilities';

const _url:string = '/player/quiz';

// Get pages
export const getQuiz = createAsyncThunk(
  `${Reducers.Quiz}/Get quiz`,
  async (slug:string, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/${slug}`, {
      method: 'GET'
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    const { quiz:quizHash, result:resultHash } = await response.json();

    const quiz:any = decodeBase64(quizHash);

    // Set quiz nonce into storage
    StorageService.setNonce(quiz.nonce);

    if ( resultHash ){
      const { id:resultId, user:userId } = decodeBase64(resultHash);
      if ( resultId ){
        if ( userId ){
          dispatch(setUserId(userId));
          StorageService.setQwid(userId);
        }
        dispatch(setResultId(resultId));
      }
    }

    return fulfillWithValue(quiz);
  }
);